import React, { useEffect, useState } from 'react';
import { signInWithPopup, GoogleAuthProvider, onAuthStateChanged, signOut } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';
import { auth, firestore } from '../config/firebaseConfig'; // Certifique-se que Firestore está configurado corretamente
import { collection, query, where, getDocs } from 'firebase/firestore'; // Funções Firestore
import './Login.css';
import logo from '../assets/logoHB.png';

const Login = () => {
  const [errorMessage, setErrorMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const navigate = useNavigate();

  const checkEmailAuthorization = async (email) => {
    try {
      console.log('Verificando e-mail autorizado para:', email);
      const inquilinosRef = collection(firestore, 'inquilinos');
      const q = query(inquilinosRef, where('emailsautorizados', 'array-contains', email));
      const querySnapshot = await getDocs(q);

      if (!querySnapshot.empty) {
        // Usa o ID do documento como tenantId
        const tenantId = querySnapshot.docs[0].id; // Obtém o ID do documento como tenantId
        const inquilinoData = querySnapshot.docs[0].data();
        console.log('Inquilino autorizado com ID (tenantId):', tenantId, 'Dados:', inquilinoData);
        
        // Armazena o tenantId no localStorage ou estado global
        localStorage.setItem('tenantId', tenantId);
        
        setIsLoggedIn(true); // Define como logado se o inquilino é encontrado
        navigate('/'); // Redireciona para a home
      } else {
        console.log('E-mail não autorizado. Saindo...');
        setIsLoggedIn(false);
        setErrorMessage('Acesso negado.');
        await signOut(auth); // Sai se o e-mail não estiver autorizado
      }
    } catch (error) {
      console.error('Erro ao verificar autorização do e-mail:', error);
      setErrorMessage('Erro ao verificar e-mail.');
      setIsLoggedIn(false);
    }
  };

  useEffect(() => {
    // Verifica o estado de autenticação do Firebase (onAuthStateChanged)
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        console.log('Usuário já autenticado:', user.email);
        // Se o usuário já está autenticado, verifica se o email é autorizado
        checkEmailAuthorization(user.email);
      } else {
        console.log('Nenhum usuário autenticado');
        setIsLoggedIn(false); // Define que não está logado
      }
    });
    return () => unsubscribe();
  }, [navigate]);  // Adiciona `navigate` como dependência para garantir que o redirecionamento funcione

  const handleLogin = async () => {
    setLoading(true);
    const provider = new GoogleAuthProvider();
    try {
      const result = await signInWithPopup(auth, provider);
      const userEmail = result.user.email;
      console.log('Usuário logado com e-mail:', userEmail);

      // Verifica se o e-mail do usuário está autorizado e obtém o tenantId
      await checkEmailAuthorization(userEmail);
    } catch (error) {
      console.error('Erro na autenticação:', error);
      setErrorMessage('Erro na autenticação. Acesso negado.');
      setIsLoggedIn(false);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="logo-container">
          <img src="https://firebasestorage.googleapis.com/v0/b/hb-escola.appspot.com/o/logos%2FaGL5hULwC15AwkR9AdF4%2Flogo.png?alt=media&token=aa613378-f92c-40cb-a805-b6912bb00fd1" alt="Logo" className="logo" />
        </div>
        <h1>Bem-vindo</h1>
        <p>Faça login para acessar sua conta.</p>
        <button className="google-login" onClick={handleLogin} disabled={loading || isLoggedIn}>
          {loading ? 'Verificando...' : (
            <>
              <img src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg" alt="Google logo" />
              Entrar com o Google
            </>
          )}
        </button>
        {errorMessage && (
          <div className="error-message">
            {errorMessage}
          </div>
        )}
      </div>
    </div>
  );
};

export default Login;
